import React from 'react';
import PropTypes from 'prop-types';
import {
    CaseStudyImage,
    CaseStudyContent,
    CaseStudyContainer,
    CaseStudyMain,
    IconContainer
  } from './index.style'
import PageTransitionLink from '@components/PageTransitionLink';
import { GatsbyImage } from 'gatsby-plugin-image';
import { Caption, Heading4Serif } from '@components/TextStyles';
import RichText from '@components/RichText';
import Spacer from '@components/Spacer';
import IconArrowRight from '@svgs/IconArrowRight'

const Item = ({data, display}) => {
    
    const {
        slug,
        title,
        mainImage,
        secondaryImage,
        heroText,
        metadata,
        parentService
    } = data;

    const backgroundImage = mainImage ? mainImage : secondaryImage;

    return (
        <CaseStudyMain className={display}>
            <PageTransitionLink to={`our-work/${slug}`} className="caseStudyImageLink">
                <CaseStudyContainer className="caseStudyContainer">
                    <CaseStudyContent className='content'>
                        <Heading4Serif as="h2" maxWidth={11.3369565217}><strong>{title}</strong></Heading4Serif>
                        {heroText &&
                            <RichText
                                content={heroText}
                                paragraphSize="heading4Serif"
                                className="title"
                                />
                        }
                        {(metadata.tags.length > 0) && 
                            <>
                            <Spacer size={[15, 40]} />
                            <Caption>
                            {(metadata.tags[0].name.split(': ').length > 1) ? metadata.tags[0].name.split(': ')[1]: metadata.tags[0].name}
                            </Caption>
                            </>
                        }

                    </CaseStudyContent>
                    {backgroundImage && 
                        <CaseStudyImage className="caseStudyImage">
                            <GatsbyImage
                                image={backgroundImage.gatsbyImageData}
                                alt={backgroundImage.description}
                            />
                        </CaseStudyImage>
                    }
                    {(display === 'list') && 
                        <IconContainer><IconArrowRight /></IconContainer>
                    }
                </CaseStudyContainer>
            </PageTransitionLink>
        </CaseStudyMain>
    );
};

Item.propTypes = {
    data: PropTypes.object,
    display: PropTypes.string,
    slug: PropTypes.string,
    title: PropTypes.string,
    mainImage: PropTypes.object,
    secondaryImage: PropTypes.object,
    heroText: PropTypes.object,
    metadata: PropTypes.object,
    parentService: PropTypes.object,
};

export default Item;